import script from "./Archive.vue?vue&type=script&setup=true&lang=ts"
export * from "./Archive.vue?vue&type=script&setup=true&lang=ts"

import "./Archive.vue?vue&type=style&index=0&id=aace1996&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aace1996"]])

export default __exports__